module.exports = __webpack_public_path__ + "static/i6-22a1fb60e0fd286bb4c78702404d3a69.jpg";